import React from "react";
import { Subtarea } from "../../../types/auditoria.types";
import { DatePicker } from "../../common/DatePicker";

interface SubtareaItemProps {
  subtarea: Subtarea;
  onRemove: () => void;
  onChange: (field: keyof Subtarea, value: string) => void;
  fechaAuditoriaInicio: string;
  fechaAuditoriaCorte: string;
  errors?: any;
  categoriaId: string;
}

export const SubtareaItem: React.FC<SubtareaItemProps> = ({
  subtarea,
  onRemove,
  onChange,
  fechaAuditoriaInicio,
  fechaAuditoriaCorte,
  errors = {},
  categoriaId,
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6 mb-4">
      {/* Nombre de la subtarea */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Nombre del requerimiento
        </label>
        <textarea
          value={subtarea.nombre}
          onChange={(e) => onChange("nombre", e.target.value)}
          rows={2}
          className={`w-full px-3 sm:px-4 py-2 border rounded-lg focus:ring-2 focus:border-transparent bg-[#F3F3F3] text-sm sm:text-base ${errors[`${categoriaId}_${subtarea.id}_nombre`] ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'}`}
          placeholder="Descripción del requerimiento..."
        />
      </div>

      {/* Prioridad, Fecha y Tiempo */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm text-gray-600 mb-2">Prioridad</label>
          <select
            value={subtarea.prioridad}
            onChange={(e) => onChange("prioridad", e.target.value)}
            className={`w-full px-3 sm:px-4 py-2 border rounded-lg focus:ring-2 focus:border-transparent bg-[#F3F3F3] text-sm sm:text-base ${errors[`${categoriaId}_${subtarea.id}_prioridad`] ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'}`}
          >
            <option value="">Seleccionar</option>
            <option value="alta">Alta</option>
            <option value="media">Media</option>
            <option value="baja">Baja</option>
          </select>
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Fecha de solicitud
          </label>
          <DatePicker
            value={subtarea.fechaSolicitud}
            disabled={!fechaAuditoriaInicio || !fechaAuditoriaCorte}
            onChange={(val) => {
              onChange("fechaSolicitud", val);
              if (subtarea.tiempoEntrega && val && subtarea.tiempoEntrega < val) {
                onChange("tiempoEntrega", "");
              }
            }}
            min={fechaAuditoriaInicio}
            max={subtarea.tiempoEntrega || fechaAuditoriaCorte}
            placeholder={!fechaAuditoriaInicio || !fechaAuditoriaCorte ? "Define fechas de auditoría" : "dd/mm/aaaa"}
            hasError={!!errors[`${categoriaId}_${subtarea.id}_fechaSolicitud`]}
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Fecha de entrega
          </label>
          <DatePicker
            value={subtarea.tiempoEntrega}
            disabled={!fechaAuditoriaInicio || !fechaAuditoriaCorte}
            onChange={(val) => onChange("tiempoEntrega", val)}
            min={subtarea.fechaSolicitud || fechaAuditoriaInicio}
            max={fechaAuditoriaCorte}
            placeholder={!fechaAuditoriaInicio || !fechaAuditoriaCorte ? "Define fechas de auditoría" : "dd/mm/aaaa"}
            hasError={!!errors[`${categoriaId}_${subtarea.id}_tiempoEntrega`]}
          />
        </div>
      </div>

      {/* Observaciones */}
      <div className="mb-4">
        <label className="block text-sm text-gray-600 mb-2">
          Observaciones
        </label>
        <textarea
          value={subtarea.observaciones}
          onChange={(e) => onChange("observaciones", e.target.value)}
          rows={2}
          className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-[#F3F3F3] text-sm sm:text-base"
          placeholder="Observaciones adicionales..."
        />
      </div>

      {/* Botón eliminar */}
      <div className="mt-4 flex justify-end">
        <button
          type="button"
          onClick={onRemove}
          className="p-2 text-white bg-red-500 hover:bg-red-600 rounded-full transition-colors flex-shrink-0"
          title="Eliminar requerimiento"
        >
          <svg
            className="h-5 w-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
